<template>
    <div class="w-full">
        <label
            v-if="label"
            :for="inputId"
            class="block mb-1 text-sm text-theme-muted font-semibold"
        >
            {{ label }}
        </label>
        <div class="relative flex items-center mt-1">
            <span
                v-if="$slots.icon"
                class="absolute left-3 flex items-center justify-center text-theme-muted"
                @click="$emit('click-icon')"
            >
                <slot name="icon" />
            </span>
            <input
                :id="inputId"
                ref="input"
                v-bind="$attrs"
                :type="type"
                :value="value"
                :placeholder="placeholder"
                :disabled="disabled"
                class="w-full rounded-md border bg-theme-input text-theme-base px-3 py-2 text-sm transition-colors focus:outline-none focus:ring-1"
                :class="[
                    $slots.icon ? 'pl-9' : '',
                    error
                        ? 'border-theme-danger focus:ring-theme-danger'
                        : 'border-theme-border focus:ring-theme-primary',
                    disabled
                        ? 'opacity-80 cursor-not-allowed text-theme-disabled'
                        : ''
                ]"
                @input="$emit('input', $event.target.value)"
                @focus="$emit('focus', $event)"
                @blur="$emit('blur', $event)"
                @keyup.enter="$emit('enter', $event)"
            />
        </div>
        <p v-if="error" class="mt-1 text-xs text-theme-danger">
            {{ error }}
        </p>
    </div>
</template>

<script>
export default {
    name: "CustomInput",
    inheritAttrs: false,
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            default: () => "",
            type: [String, Number],
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        type: {
            default: () => "text",
            type: String,
            required: false
        },
        placeholder: {
            default: () => "",
            type: String,
            required: false
        },
        error: {
            default: () => "",
            type: String,
            required: false
        },
        disabled: {
            default: () => false,
            type: Boolean,
            required: false
        },
        id: {
            default: () => "",
            type: String,
            required: false
        }
    },
    emits: ["input", "focus", "blur", "enter", "click-icon"],
    computed: {
        inputId() {
            return this.id || `custom-input-${this._uid}`;
        }
    }
};
</script>
